<div class="card card-primary mt-4 without-shadow" [ngClass]="{'liveView': liveView}">
  <div class="d-flex justify-content-between align-items-center">
    <h4 class="main-title d-flex align-items-center">{{ 'studyList.Radiology List' | translate }} <span class="badge badge-secondary mx-2">{{studyList?.list?.length}}</span></h4>
    <button class="btn add-btn" *ngIf="studyList?.canAdd && !liveView" (click)="openUploadStudyForm = true;">
        <svg width="14" height="14" viewBox="0 0 14 14">
            <path id="plus"
                d="M5.279,12.1V8.719H1.911A1.824,1.824,0,0,1,0,7,1.819,1.819,0,0,1,1.911,5.285H5.279V1.91A1.826,1.826,0,0,1,7,0,1.823,1.823,0,0,1,8.721,1.91V5.285h3.373A1.817,1.817,0,0,1,14,7a1.823,1.823,0,0,1-1.906,1.719H8.721V12.1A1.819,1.819,0,0,1,7,14,1.822,1.822,0,0,1,5.279,12.1Z"
                fill="#fff" opacity="0.9" />
        </svg>
    </button>
  </div>
  <!-- <div class="card-header pr-0">
    {{ 'studyList.Radiology List' | translate }}<span class="badge badge-secondary"
    *ngIf='!dataLoading'>{{studyList?.list?.length}}</span>
    <button class="btn add-btn" *ngIf="studyList?.canAdd && !liveView"
      (click)="openUploadStudyForm = true;">
      <svg width="14" height="14" viewBox="0 0 14 14">
        <path id="plus"
          d="M5.279,12.1V8.719H1.911A1.824,1.824,0,0,1,0,7,1.819,1.819,0,0,1,1.911,5.285H5.279V1.91A1.826,1.826,0,0,1,7,0,1.823,1.823,0,0,1,8.721,1.91V5.285h3.373A1.817,1.817,0,0,1,14,7a1.823,1.823,0,0,1-1.906,1.719H8.721V12.1A1.819,1.819,0,0,1,7,14,1.822,1.822,0,0,1,5.279,12.1Z"
          fill="#fff" opacity="0.9" />
      </svg>
    </button>
  </div> -->
  <div class="card-body px-0">
    <div class="dataLoading" *ngIf="dataLoading">
      <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>

    <ng-container *ngIf="!dataLoading">
      <!-- <div class="empty-data-add" *ngIf="!studyList.length">
        <p>{{ 'studyList.No Radiology(ies) add yet' | translate }}</p>
        <div>
           *ngIf="meeting.meetingInviteePermissions.canUploadPathologySlides"
          <button class="btn btn-blue"
            (click)="openUploadStudyForm = true;">
            {{'studyList.Add Radiology' | translate}}
          </button>
        </div>
      </div> -->
      <div class="accordion-container large" id="expandRow" *ngIf="studyList?.list?.length; else dataEmpty">
        <div class="card-container pb-2 mb-0" *ngFor="let parent of studyList?.list; index as i">
          <div class="panel-header" (click)='expand(i, "expandRow")'>
            <div class="flex-grow-1">
              <div class="row">
                <div class="col-4">
                  <span>{{'studyList.Patient Name' | translate}}</span>
                  <p>{{parent.patientName}}</p>
                </div>
                <div class="col-4">
                  <span>{{'studyList.MRN' | translate}}</span>
                  <p>{{parent.mrn}}</p>
                </div>
                <div class="col-4">
                  <span>{{'studyList.Gender' | translate}}</span>
                  <p>{{parent.patientGender}}</p>
                </div>
              </div>
            </div>
            <div>
              <svg class="up" width="15" height="9" viewBox="0 0 15 9">
                <path id="menu-icon" d="M806.028,397.634l-5.968,5.949-1.532-1.527,7.5-7.473,7.5,7.473L812,403.582Z"
                  transform="translate(-798.528 -394.583)" fill="#999" />
              </svg>
              <svg class="down" width="15" height="9" viewBox="0 0 15 9">
                <path id="menu-icon" d="M806.028,400.532l-5.968-5.949-1.532,1.527,7.5,7.473,7.5-7.473L812,394.584Z"
                  transform="translate(-798.528 -394.583)" fill="#999" />
              </svg>
            </div>
          </div>
          <div class="panel-content">
            <div class="table-container mt-2">
              <div class="table-responsive">
                <table class="table mat-table">
                  <thead role="rowgroup">
                    <tr class="mat-header-row">
                      <th class="mat-header-cell"> {{'studyList.Accession' | translate}} </th>
                      <th class="mat-header-cell"> {{'studyList.Study Date' | translate}} </th>
                      <th class="mat-header-cell"> {{'studyList.Modality' | translate}} </th>
                      <th class="mat-header-cell"> {{'studyList.Description' | translate}} </th>
                      <th class="mat-header-cell"></th>
                    </tr>
                  </thead>
                  <tbody role="rowgroup">
                    <tr class="mat-row" *ngFor="let study of parent.studyList">
                      <td class="mat-cell">
                        {{study.accession}}
                      </td>
                      <td class="mat-cell">
                        {{study.studyDate.slice(0,4)}}-{{study.studyDate.slice(4,6)}}-{{study.studyDate.slice(6,8)}}
                      </td>
                      <td class="mat-cell">
                        {{study.modality}}
                      </td>
                      <td class="mat-cell">
                        {{study.description}}
                      </td>
                      <td class="mat-cell">
                         <!-- *ngIf="meeting.meetingInviteePermissions.canUploadPathologySlides" -->
                        <div class="d-inline-block tableOptions-container">
                          <button class="btn btn-outline-primary p-0" [matMenuTriggerFor]="menu">
                            <svg width="24" height="6" viewBox="0 0 24 6" class="m-0">
                              <path id="show-actions-menu-btn" d="M5610.879,13616.122a3,3,0,1,1,2.121.879A3,3,0,0,1,5610.879,13616.122Zm-9,0a3,3,0,1,1,2.121.879A3,3,0,0,1,5601.878,13616.122Zm-9,0a3,3,0,1,1,2.121.879A3,3,0,0,1,5592.878,13616.122Z" transform="translate(-5592 -13611.001)" fill="#666" />
                            </svg>
                          </button>
                          <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="openStudyViewer(study.studyUID)">
                              <svg width="20" height="13" viewBox="0 0 20 13">
                                <path id="view-icon"
                                  d="M5612.231,13468.172a1.087,1.087,0,0,1,0-1.345c1.088-1.367,4.972-5.828,9.767-5.828s8.679,4.461,9.767,5.828a1.087,1.087,0,0,1,0,1.345c-1.088,1.367-4.972,5.827-9.767,5.827S5613.319,13469.539,5612.231,13468.172Zm5.105-.673a4.662,4.662,0,1,0,4.662-4.706A4.685,4.685,0,0,0,5617.336,13467.5Zm1.443,0a3.219,3.219,0,1,1,3.219,3.25A3.238,3.238,0,0,1,5618.779,13467.5Zm1.177-.224h1.065a.742.742,0,0,1,.732-.739v-1.076A1.828,1.828,0,0,0,5619.956,13467.275Z"
                                  transform="translate(-5611.998 -13460.999)" fill="#92bcd2" />
                              </svg>
                              <span>{{ 'group.view' | translate }}</span>
                            </button>
                            <button mat-menu-item *ngIf="study.canDelete" (click)="DeleteMeetingDicomFile(study.studyUID, meetingId)">
                              <svg width="14.997" height="20" viewBox="0 0 14.997 20">
                                <path id="delete-icon" d="M5615.926,13481a3.242,3.242,0,0,1-3.238-3.238v-10.507a.673.673,0,0,1,.672-.673h12.275a.673.673,0,0,1,.672.673v10.507a3.242,3.242,0,0,1-3.239,3.238Zm5.188-10.367v6.316a.826.826,0,0,0,1.653,0v-6.316a.826.826,0,0,0-1.653,0Zm-4.886,0v6.316a.826.826,0,0,0,1.653,0v-6.316a.826.826,0,0,0-1.653,0Zm-3.807-4.824a.423.423,0,0,1-.422-.423v-1.3a2.036,2.036,0,0,1,2.035-2.034h2.93v-.254a.793.793,0,0,1,.792-.793h3.483a.793.793,0,0,1,.792.793v.254h2.93a2.036,2.036,0,0,1,2.035,2.034v1.3a.423.423,0,0,1-.422.423Z" transform="translate(-5612 -13461)" fill="#92bcd2" />
                              </svg>
                              <span> {{ 'users.Delete' | translate }}</span>
                            </button>
                          </mat-menu>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ng-template #dataEmpty>
        <div class="data-empty no-bg">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="110"
                height="99.999" viewBox="0 0 110 99.999">
                <defs>
                    <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                        <stop offset="0" stop-color="#469595" />
                        <stop offset="1" stop-color="#0b7ebc" />
                    </linearGradient>
                    <linearGradient id="linear-gradient-2" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                        <stop offset="0" stop-color="#469595" />
                        <stop offset="1" stop-color="#14374D" />
                    </linearGradient>
                </defs>
                <g id="no-members-illustration" transform="translate(-823 -642)">
                    <path id="Path_2516" data-name="Path 2516"
                        d="M99.268,21.663c0,22.014,11.315,37.132,11.315,47.74s-6.051,32.886-54.471,32.886S.583,72.318.583,60.65c0-54.637,98.685-77.975,98.685-38.987Z"
                        transform="translate(822.417 639.71)" fill="#efefef" opacity="0.6" />
                    <g id="Group_764" data-name="Group 764" transform="translate(839.484 647.141)">
                        <path id="Path_2517" data-name="Path 2517" d="M0,0H6.365V3.183H0Z"
                            transform="translate(12.941 4.508) rotate(-45)" fill="#9fbfcf" />
                        <path id="Path_2518" data-name="Path 2518" d="M0,0H6.365V3.183H0Z"
                            transform="translate(0 17.443) rotate(-45)" fill="#9fbfcf" />
                        <path id="Path_2519" data-name="Path 2519" d="M0,0H3.183V6.365H0Z"
                            transform="translate(0.562 2.25) rotate(-45)" fill="#9fbfcf" />
                    </g>
                    <path id="shadow"
                        d="M37.154,11.75H29A7.247,7.247,0,0,0,21.75,19v4.531H29.9V19A7.247,7.247,0,0,1,37.154,11.75Z"
                        transform="translate(870.018 657.366)" fill="#d5dbe1" />
                    <path id="Union_1" data-name="Union 1"
                        d="M-431.043,7160.122v-3.544a5.338,5.338,0,0,0-5.347-5.315h-10.7a5.338,5.338,0,0,0-5.347,5.315v3.544a1.778,1.778,0,0,1-1.783,1.771,1.777,1.777,0,0,1-1.783-1.771v-3.544a8.9,8.9,0,0,1,8.913-8.859h10.7a8.9,8.9,0,0,1,8.911,8.859v3.544a1.776,1.776,0,0,1-1.781,1.771A1.777,1.777,0,0,1-431.043,7160.122Zm-17.827-23.035a7.116,7.116,0,0,1,7.13-7.087,7.116,7.116,0,0,1,7.13,7.087,7.117,7.117,0,0,1-7.13,7.089A7.117,7.117,0,0,1-448.87,7137.087Zm3.566,0a3.557,3.557,0,0,0,3.564,3.544,3.559,3.559,0,0,0,3.566-3.544,3.558,3.558,0,0,0-3.566-3.543A3.557,3.557,0,0,0-445.3,7137.087Z"
                        transform="translate(1346.478 -6480.998)" fill="url(#linear-gradient)" />
                    <path id="shadow-2" data-name="shadow"
                        d="M14.909,36.413A22.658,22.658,0,0,1,33.492,14.134a22.656,22.656,0,1,0-4.079,44.941,22.879,22.879,0,0,0,4.079-.384A22.658,22.658,0,0,1,14.909,36.413Z"
                        transform="translate(831.25 662.25)" fill="#d5dbe1" />
                    <path id="Union_2" data-name="Union 2"
                        d="M-398.49,7189.673l-16.121-16.021a24.937,24.937,0,0,1-16.432,6.152A24.911,24.911,0,0,1-456,7155a24.911,24.911,0,0,1,24.958-24.8,24.911,24.911,0,0,1,24.956,24.8,24.615,24.615,0,0,1-6.017,16.137l16.135,16.032a1.768,1.768,0,0,1,0,2.506,1.781,1.781,0,0,1-1.26.518A1.792,1.792,0,0,1-398.49,7189.673ZM-452.435,7155a21.349,21.349,0,0,0,21.392,21.263A21.348,21.348,0,0,0-409.652,7155a21.347,21.347,0,0,0-21.391-21.26A21.348,21.348,0,0,0-452.435,7155Zm32.088,12.211v-3.544a5.338,5.338,0,0,0-5.349-5.314h-10.7a5.338,5.338,0,0,0-5.349,5.314v3.544a1.777,1.777,0,0,1-1.781,1.772,1.777,1.777,0,0,1-1.783-1.772v-3.544a8.9,8.9,0,0,1,8.912-8.858h10.7a8.9,8.9,0,0,1,8.912,8.858v3.544a1.777,1.777,0,0,1-1.781,1.772A1.777,1.777,0,0,1-420.348,7167.209Zm-17.827-23.033a7.116,7.116,0,0,1,7.131-7.088,7.115,7.115,0,0,1,7.13,7.088,7.115,7.115,0,0,1-7.13,7.086A7.115,7.115,0,0,1-438.174,7144.176Zm3.566,0a3.557,3.557,0,0,0,3.566,3.542,3.556,3.556,0,0,0,3.564-3.542,3.557,3.557,0,0,0-3.564-3.544A3.557,3.557,0,0,0-434.609,7144.176Z"
                        transform="translate(1293 -6456.192)" fill="url(#linear-gradient-2)" />
                </g>
            </svg>
            <p>{{ 'general.NoFound' | translate }}</p>
        </div>
    </ng-template>
    </ng-container>
  </div>
</div>
<app-upload-study *ngIf="openUploadStudyForm" [meetingId]='meetingId' [study]="selectedStudy"
  (cancelPop)='openUploadStudyForm = false' (closePopAndSave)='openUploadStudyForm = false; GetMeetingDicomFiles()'
  [agendaItemId]="meetingAgendaItemId">
</app-upload-study>
